import { Component, OnInit, Inject } from '@angular/core';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IMsgHistoryInputModel } from 'src/app/ViewModel/CommunicationModel';
import { CommonService } from 'src/app/Service/Common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-mail-history-log',
  templateUrl: './mail-history-log.component.html',
  styleUrls: ['./mail-history-log.component.css']
})
export class MailHistoryLogComponent implements OnInit {
  projectId: number = 0;
  groupId: number = 0;
  memberId: number = 0;
  public historyList: any[] = [];

  constructor(
    private communicationService: CommunicationService,
    public commonService: CommonService,
    public dialogRef: MatDialogRef<MailHistoryLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.initGrid(this.data.messageId);
  }

  public async initGrid(msgId: number) {
    let inputModel: IMsgHistoryInputModel = {
      projectId: this.projectId,
      groupId: this.groupId,
      messageId: msgId,
      memberId: this.memberId,
      roleId: 2
    };
    this.historyList = await this.communicationService.getMessageHistoryDetails(inputModel).toPromise();
  }
  public togglePopupDialog() {
    this.dialogRef.close();
  }

}
